import type { ReactNode } from "react";
import type { PageContext } from "vike/types";
import { CheckoutDrawer } from "@/components/CheckoutDrawer";
import { CookieConsent } from "@/components/CookieConsent";
import { StickyCtaBar } from "@/components/StickyCtaBar/StickyCtaBar";
import { WebChatBoot } from "@/components/WebChat/WebChatBoot";
import { CheckoutProvider } from "@/context/CheckoutContext";
import type { VikePageContext, VikePageContextServer } from "@/types/config";

export { PageShell };

// Single-action funnel landings suppress the global "Написать в Telegram"
// StickyCtaBar (support contact) — a floating support button competes with the
// page's sole registration CTA. Same rationale as NO_JIVO_PAGE_NAMES in
// +onRenderHtml.tsx (keep the two lists in sync when adding a funnel page).
const NO_STICKY_CTA_PAGE_NAMES = new Set(["webinars/top-8-resume-errors"]);

interface PageShellProps {
  children: ReactNode;
  pageContext: PageContext | VikePageContext | VikePageContextServer;
}

function PageShell({ children, pageContext }: PageShellProps) {
  const pageName = (pageContext.pageProps as { pageName?: string } | undefined)?.pageName;
  const showStickyCta = !(typeof pageName === "string" && NO_STICKY_CTA_PAGE_NAMES.has(pageName));

  return (
    <CheckoutProvider>
      {children}
      <CheckoutDrawer />
      {showStickyCta && (
        <StickyCtaBar
          text="Написать в Telegram"
          href="https://t.me/lenacareer_care"
          variant="accent"
        />
      )}
      <CookieConsent />
      <WebChatBoot pageName={pageName} />
    </CheckoutProvider>
  );
}
